import React from "react";

// Mui Styles
import { ThemeProvider } from "@mui/material/styles";
import { StyledPaper } from "@/styles/mui/globalStyles";
import { TableListTheme } from "@/styles/mui/tableListTheme";
import IconButton from "@mui/material/IconButton";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
// Navigate
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";

// Components
import Layout from "@/components/layout";
import Title from "@/components/title";
import DataTable from "@/components/dataTable";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import RosterExportPopUp from "@/components/rosterExportPopUp";

// Fetch
import { getAllPromoter } from "@/fetch/fetchStaff";
import { getAllWorkLocation } from "@/fetch/fetchWork";
import { importRoster } from "@/fetch/fetchRoster";
import extractRoster from "@/lib/extractRoster";
import { useCurrentAction } from "@/hooks/user";

// Config
import {
  RosterStaffTableColumn,
  RosterShopTableColumn,
} from "@/config/tableColumnConfig";
import _ from "lodash";
const SystemSettingRosterPage = (props) => {
  const { open, setOpen } = props;
  const actions = useCurrentAction();

  const [searchParams, setSearchParams] = useSearchParams();
  const [snackSeverity, setSnackSeverity] = React.useState("success");
  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [page, setPage] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [dataTable, setDataTable] = React.useState([]);
  const [dataTableConfig, setDataTableConfig] = React.useState([]);
  const [dataTableLoading, setDataTableLoading] = React.useState(false);

  // Navigate
  const navigate = useNavigate();

  // States

  const onCellClick = (data) => {
    if (data.field === "__check__") return;
    else navigate(`${page}/${data.id}`);
  };

  // Fetch
  const fetchAll = async () => {
    try {
      setDataTableLoading(true);
      switch (searchParams.get("tab")) {
        case "location":
          setDataTableConfig(RosterShopTableColumn);
          setPage("location");
          await getAllWorkLocation().then((data) => {
            if (data && data.results) {
              setDataTable(data.data);
            }
          });
          break;
        case "user":
        default:
          setDataTableConfig(RosterStaffTableColumn);
          setPage("user");
          await getAllPromoter().then((data) => {
            if (data && data.results) {
              let tempArr = [...data.data];
              for (let i = 0; i < tempArr.length; i++) {
                delete tempArr[i].shop_permission;
              }
              setDataTable(tempArr);
            }
          });
          break;
      }
    } catch (error) {
    } finally {
      setDataTableLoading(false);
    }
  };

  const handleChange = (event, newValue) => {
    setSearchParams({ tab: newValue });
  };
  const handleImport = async (e) => {
    try {
      setLoading(true);
      setSnackSeverity("info");
      setSnackMessage("上載中.....");
      setSnackOpen(true);

      const rosterData = await extractRoster(e);
      await importRoster(rosterData);
      setSnackSeverity("success");
      setSnackMessage("上載成功");
    } catch (err) {
      if (axios.isAxiosError(err)) {
        setSnackSeverity("error");
        setSnackMessage(`上載失敗\n${err.message}`);
      } else {
        const answer = window.confirm(
          `以下更表重複\n${err.error.join(`\n`)} \n要繼續上載嗎？`
        );
        if (answer) {
          try {
            await importRoster(err.data);
            setSnackSeverity("success");
            setSnackMessage("上載成功");
          } catch (error) {
            setSnackSeverity("error");
            setSnackMessage(`上載失敗\n${err.message}`);
          }
        } else {
          setSnackSeverity("warning");
          setSnackMessage("已取消上載");
        }
        //setSnackMessage(`上載失敗\n${err.error.join(`\n`)}`);
      }
      console.log("err", err);
    } finally {
      setLoading(false);
      e.target.value = null;
    }
  };
  React.useEffect(() => {
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);
  return (
    <Layout
      header="RosterPage"
      selectedIndex={25}
      open={open}
      setOpen={setOpen}
      snackOpen={snackOpen}
      snackMessage={snackMessage}
      snackSeverity={snackSeverity}
      snackClose={() => setSnackOpen(false)}
    >
      <Title
        history={() => navigate(-1)}
        title="更表"
        children={
          <>
            <Tabs
              value={searchParams.get("tab") ?? "user"}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab label="員工" value="user" />
              <Tab label="店鋪" value="location" />
            </Tabs>
            <div>
              {actions?.upload && (
                <IconButton component="label" disabled={loading}>
                  <DriveFolderUploadIcon />
                  <input
                    hidden
                    type={"file"}
                    id={"csvFileInput"}
                    accept={".xlsx"}
                    onChange={async (e) => {
                      handleImport(e);
                    }}
                  />
                </IconButton>
              )}
              {actions?.download && (
                <IconButton component="label">
                  <RosterExportPopUp
                    setSnackMessage={setSnackMessage}
                    setSnackOpen={setSnackOpen}
                    setSnackSeverity={setSnackSeverity}
                    {...{
                      ...props,
                    }}
                  />
                </IconButton>
              )}
              {/* <IconButton component="label" onClick={() => exportRoster()}>
                <DownloadIcon />
              </IconButton> */}
            </div>
          </>
        }
      />
      <StyledPaper page={"yes"}>
        <ThemeProvider theme={TableListTheme}>
          <DataTable
            loading={dataTableLoading}
            rows={dataTable}
            columns={dataTableConfig}
            onCellClick={(params) => onCellClick(params)}
            checkboxSelection={false}
          />
        </ThemeProvider>
      </StyledPaper>
    </Layout>
  );
};

export default SystemSettingRosterPage;
